import { ApplicationType } from '@testsigmainc/constants';
import { useTranslation } from '@testsigma/atoms';
import { OnboardingAplicationTile } from './application-tile';
import { UseBaseHooks } from '@hooks/use-base.hooks';
import { Feature } from '@enums/feature.enum';

const applicationTypes = [
  {
    type: ApplicationType.WebApplication,
    i18n: 'application.type.WebApplication',
    icon: 'web',
  },
  {
    type: ApplicationType.MobileWeb,
    i18n: 'application.type.MobileWeb',
    icon: 'mobile-web',
  },
  {
    type: ApplicationType.AndroidNative,
    i18n: 'application.type.AndroidNative',
    icon: 'android',
  },
  {
    type: ApplicationType.IOSNative,
    i18n: 'application.type.IOSNative',
    icon: 'ios',
  },
  {
    type: ApplicationType.Rest,
    i18n: 'application.type.Rest',
    icon: 'rest-api',
  },
  {
    type: ApplicationType.WINDOWS,
    i18n: 'application.type.WINDOWS',
    icon: 'windows-lite',
  },
  {
    type: ApplicationType.WINDOWS_ADVANCED,
    i18n: 'application.type.WINDOWS_ADVANCED',
    icon: 'desktop-windows',
    featureName: Feature.TS_WIN_TEST_AUTOMATION,
  },
];

interface OnboardingAplicationSelectorProps {
  selectedType: ApplicationType;
  onSelect: (type: ApplicationType) => void;
}

export const OnboardingAplicationSelector: React.FC<
  OnboardingAplicationSelectorProps
> = ({ selectedType, onSelect }) => {
  const { t } = useTranslation();
  const { hasFeature } = UseBaseHooks();
  return (
    <>
      <div className='text-sm font-medium text-unique-800'>
        {t('common.application.type')}
      </div>

      <div className='flex gap-x-6 mt-4'>
        {applicationTypes.map((appType) => {
          if (
            (appType?.featureName && hasFeature(appType?.featureName)) ||
            !appType?.featureName
          ) {
            return (
              <OnboardingAplicationTile
                key={appType.type}
                icon={appType.icon}
                type={appType.type}
                i18n={appType.i18n}
                isSelected={appType.type == selectedType}
                onSelect={onSelect}
              />
            );
          }
          return null;
        })}
      </div>
    </>
  );
};
